export default {
    table: {
        titles: {
            reserved_by: 'Reserved by',
            received: 'Received',
            offer: 'Service',
            location: 'Location',
            created_date: 'Date created',
            scheduled_for: 'Scheduled for',
            status: 'Status',
        },
    },
    other: {
        add_to_calendar: 'Add to calendar',
        tooltip:
            ' By clicking this button, the reservation will be added to your Apple or Google calendar. The email address of the person who made the reservation will automatically be copied to the clipboard, so you can easily add the user or guest to the event.',
    },
}
